import { render, staticRenderFns } from "./udlandspriser.vue?vue&type=template&id=41cd17cf"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RoamingInternationalPrices: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/Roaming/InternationalPrices.vue').default})
